import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const prefix = 'studentManagement.tabs.studentDocuments';

export function useTexts() {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      tabTitle: t(`${prefix}.tabTitle`),
      documentsTuitionTitle: t(`${prefix}.documentsTuitionTitle`),
      documentsOthersTitle: t(`${prefix}.documentsOthersTitle`),
      createStudentDocument: t(`${prefix}.createStudentDocument`),
      noResults: t(`${prefix}.noResults`),
      documentsTuitionTable: {
        name: t(`${prefix}.documentsTuitionTable.name`),
        period: t(`${prefix}.documentsTuitionTable.period`),
        studyPlan: t(`${prefix}.documentsTuitionTable.studyPlan`),
        fileName: t(`${prefix}.documentsTuitionTable.fileName`),
        action: t(`${prefix}.documentsTuitionTable.action`),
      },
      documentsOthersTable: {
        name: t(`${prefix}.documentsOthersTable.name`),
        description: t(`${prefix}.documentsOthersTable.description`),
        fileName: t(`${prefix}.documentsOthersTable.fileName`),
        action: t(`${prefix}.documentsOthersTable.action`),
      },
      modal: {
        title: t(`${prefix}.modal.title`),
        inputs: {
          name: {
            label: t(`${prefix}.modal.inputs.name.label`),
            placeholder: t(`${prefix}.modal.inputs.name.placeholder`),
          },
          description: {
            label: t(`${prefix}.modal.inputs.description.label`),
            placeholder: t(`${prefix}.modal.inputs.description.placeholder`),
          },
          file: {
            label: t(`${prefix}.modal.inputs.file.label`),
            btnReplace: t(`${prefix}.modal.inputs.file.btnReplace`),
            btn: t(`${prefix}.modal.inputs.file.btn`),
          },
        },
        buttons: {
          close: t(`${prefix}.modal.buttons.close`),
          create: t(`${prefix}.modal.buttons.create`),
        },
        success: t(`${prefix}.modal.success`),
        error: t(`${prefix}.modal.error`),
      },
      modalDelete: {
        title: t(`${prefix}.modalDelete.title`),
        body: t(`${prefix}.modalDelete.body`),
        delete: t(`${prefix}.modalDelete.delete`),
        cancel: t(`${prefix}.modalDelete.cancel`),
        success: t(`${prefix}.modalDelete.success`),
        error: t(`${prefix}.modalDelete.error`),
      },
      toast: {
        success: t(`${prefix}.toast.success`),
        error: t(`${prefix}.toast.error`),
      },
    }),
    [t],
  );
}
